import { Component, OnInit, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { Router, NavigationStart, } from '@angular/router';
import { Observable, fromEvent, } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { FormControl } from '@angular/forms';
import { HpService } from 'projects/hp-api/src/lib/services/hp.service';
import { WizardHpBaseComponent } from '../base/wizard/wizard-hp-base-component';

export interface Product {
  cat_homolog: string
  descriptive: string,
  id: string,
  keyword_sys: any,
  kind: number,
  leaf: boolean,
  libelle: string,
  order: number,
  price: any,
  question: number,
  sold: any,
  stock: any,
  visuel: string
};
@Component({
  selector: 'app-familles-child',
  templateUrl: './familles-child.component.html',
  styleUrls: ['./familles-child.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FamillesChildComponent extends WizardHpBaseComponent implements OnInit {

  public sous_famille: any;
  public products: any;
  public famId: any;
  searchControl = new FormControl();
  filteredOptions?: Observable<Product[]>;
  options: Product[] = [];
  p: number = 1;
  pages = [];
  pageOfItems?: Array<any>;
  ElementsByPage = 14;
  constructor(chgDetectorRef: ChangeDetectorRef, hpService: HpService, router: Router) {

    super(chgDetectorRef, hpService, router);

    this.sous_famille = this.getHpService().getDataSousFamilles();
    this.getHpService().setCurrentPage(2);
    this.getHpService().setHeaderIn(true);
    this.getHpService().setEtape_final(false);
    this.getHpService().setCurrentPage(this.getIndexNextUrl('familles'));
  }

  ngOnInit() {

    if (!this.sous_famille) {
      this.getRouter().navigate([this.getHpService().getConfig().herculepro.slug]);
    }
    this.options = (this.sous_famille) ? this.sous_famille.root.data : [];
    this.filteredOptions = this.searchControl.valueChanges
      .pipe(
        startWith(''),
        map(value => typeof value === 'string' ? value : value.Modele),
        map(name => name ? this._filter(name) : this.options.slice())
      );

  }
  private _filter(name: string): Product[] {
    const filterValue = name.toLowerCase();
    return this.options.filter(option => option.libelle.toLowerCase().includes(filterValue));
  }
  public fetchSousFamilles(famId: any, leaf: boolean) {

    let params = this.getHpService().getParameters() + "/" + famId;
    if (leaf) {

      this.getHpService().fetchProducts(this.getHpService().getCatId(), params).subscribe(data => {
        this.products = data;
        this.famId = famId;
        this.getHpService().setParameters(famId);
        this.getHpService().setListProducts(data);
        this.getHpService().setCurrentPage(this.getIndexNextUrl('liste-produits'))
        this.getRouter().navigate(['liste-produits']);

      });
      return;

    }

    this.getHpService().fetchFamilles(this.getHpService().getCatId(), params).subscribe(data => {
      debugger;
      if (data.root.data[0].leaf && data.root.data.length === 1) {
        let params_ = this.getHpService().getParameters() + "/" + data.root.data[0].id;
        this.getHpService().fetchProducts(this.getHpService().getRootProduct(), params_).subscribe(data => {

          this.products = data;
          this.famId = data.root.data[0].id;
          this.getHpService().setParameters(data.root.data[0].id);
          this.getHpService().setListProducts(data);
          this.getHpService().setPanneaux(data)
          this.getHpService().setCurrentPage(this.getIndexNextUrl('liste-produits'))
          this.getRouter().navigate(['liste-produits']);
        });
        return;

      }



      this.sous_famille = data;
      this.options = this.sous_famille.root.data;
      this.filteredOptions = this.searchControl.valueChanges
        .pipe(
          startWith(''),
          map(value => typeof value === 'string' ? value : value.Modele),
          map(name => name ? this._filter(name) : this.options.slice())
        );

      this.famId = famId;
      this.getHpService().setParameters(this.getHpService().getParameters() + "/" + famId);

    });
  }
}
